import { useTranslation as e } from "../../i18n.mjs";
import { toast as t } from "../../components/toast/index.mjs";
import { CircleToSquareSwapIcon as n } from "../../icons/circle-to-square-swap.mjs";
import { SquareToCircleSwapIcon as r } from "../../icons/square-to-circle-swap.mjs";
import { Modal as i } from "../../components/modal/index.mjs";
import { ImageCropper as a } from "./image-cropper.mjs";
import { Button as o, ToggleControl as s } from "@systemeio/components";
import { useRef as c, useState as l } from "react";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
//#region src/modules/image-cropper/image-cropper-modal.tsx
function f({ imageFile: f, opened: p, actionButtonLabel: m, isFetching: h, onClose: g, onCrop: _, isRounded: v = !1, allowSwitchingCroppingShape: y = !1, ...b }) {
	let { t: x } = e(), S = c(null), [C, w] = l(!1), [T, E] = l(v), D = (e) => {
		w(e), e ? S.current?.showPreview() : S.current?.hidePreview();
	}, O = async () => {
		try {
			let e = await S.current?.getCroppedFile();
			if (!e) throw Error();
			_(e);
		} catch {
			t.error(x("file_manager.error"));
		}
	};
	return /* @__PURE__ */ d(i, {
		title: x("file_manager.file_upload.crop_file"),
		opened: p,
		onClose: g,
		afterLeave: () => w(!1),
		isFetching: h,
		children: [/* @__PURE__ */ u(a, {
			imageCropperRef: S,
			imageFile: f,
			isRounded: y ? T : v,
			...b
		}), /* @__PURE__ */ d("div", {
			className: "mt-10 flex items-center justify-between gap-5",
			children: [/* @__PURE__ */ d("div", {
				className: "flex flex-wrap gap-5",
				children: [/* @__PURE__ */ u(s, {
					checked: C,
					label: x("file_manager.preview"),
					onCheckedChange: D
				}), y && !C && /* @__PURE__ */ d(o, {
					"aria-pressed": T,
					onClick: () => E((e) => !e),
					size: "sm",
					variant: "secondary",
					children: [u(T ? n : r, {}), x(T ? "file_manager.image_cropper.rounded_crop" : "file_manager.image_cropper.square_crop")]
				})]
			}), /* @__PURE__ */ u(o, {
				onClick: O,
				isLoading: h,
				children: m ?? x("file_manager.file_upload.crop_file")
			})]
		})]
	});
}
//#endregion
export { f as ImageCropperModal };
